import { useHookstate } from "@hookstate/core";
import { useGlobalMiscState } from "../../stores/misc";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import { ChevronLeft } from "../../assets/icons/ChevronLeft";
import { Demerit, DisciplinaryCase } from "../../types";
import { ChevronRight } from "../../assets/icons/ChevronRight";
import { getDateOnly, updateMiscState } from "../../misc/utils";
import { Avatar } from "../Avatar";
import { useUniversalFind } from "../../hooks/universal";
import { FileUploadWithPreview } from "../FileUploadWithPreview";
import { useEffect } from "react";

export const DisciplinaryDemeritView = () => {
  const allDocumentLabels: Record<string, any>[] = useUniversalFind("Config", {
    key: "demerit_document_labels",
  });
  const documentLabels: any[] = allDocumentLabels[0]?.value || [];
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const currentIndex = state.currentIndex || 0;
  const miscState = useGlobalMiscState();
  const disciplinaryCasesDemeritCurrentCase: DisciplinaryCase =
    miscState.get("disciplinaryCasesDemeritCurrentCase") || {};
  const disciplinaryCasesDemeritCurrentDemerit: Demerit =
    miscState.get("disciplinaryCasesDemeritCurrentDemerit") || {};

  useEffect(() => {
    const foundIndex = disciplinaryCasesDemeritCurrentCase.demerits.findIndex(
      (d) => d.id === disciplinaryCasesDemeritCurrentDemerit.id,
    );
    if (foundIndex >= 0) {
      localState.merge({
        currentIndex: foundIndex,
      });
    }
  }, []);

  useEffect(() => {
    if (disciplinaryCasesDemeritCurrentCase.demerits?.[currentIndex]) {
      updateMiscState("disciplinaryCasesDemeritCurrentDemerit")({
        ...disciplinaryCasesDemeritCurrentCase.demerits?.[currentIndex],
      });
    }
  }, [currentIndex, disciplinaryCasesDemeritCurrentCase.demerits?.length]);

  const updateIndex = (type: string) => () => {
    localState.merge({
      currentIndex: currentIndex + (type === "increment" ? 1 : -1),
    });
  };

  return (
    <div className='flex flex-col flex-1 overflow-y-auto'>
      <div className='flex flex-row bg-valley-gray px-6 py-[17px]'>
        <button
          disabled={currentIndex === 0}
          onClick={updateIndex("decrement")}
          className={`rounded-md opacity-60 bg-valley-background-blue p-2 justify-center items-center`}
        >
          <ChevronLeft />
        </button>
        <div className='flex-1 flex flex-row justify-center items-center'>
          <span className='text-2xl leading-[26.4px] text-white'>
            Дело №{disciplinaryCasesDemeritCurrentCase.id}.{" "}
            {disciplinaryCasesDemeritCurrentCase.name}
          </span>
        </div>
        <button
          disabled={
            currentIndex ===
            disciplinaryCasesDemeritCurrentCase.demerits.length - 1
          }
          onClick={updateIndex("increment")}
          className={`rounded-md opacity-60 bg-valley-background-blue p-2 justify-center items-center`}
        >
          <ChevronRight />
        </button>
      </div>
      <div className='mt-1 flex-1 rounded-xl flex flex-col bg-white p-6 overflow-y-auto'>
        <p className='flex flex-row text-2xl'>
          <span className='text-valley-light-gray mr-1'>Выговор</span>
          <span className='text-valley-black'>
            {disciplinaryCasesDemeritCurrentDemerit.demerit_type.name}
          </span>
        </p>
        <p className='mt-0.5 text-[15px] text-valley-gray'>
          <span className='mr-2'>
            Создан{" "}
            {getDateOnly(disciplinaryCasesDemeritCurrentDemerit.createdAt)}
          </span>
          <span>
            Изменён{" "}
            {getDateOnly(disciplinaryCasesDemeritCurrentDemerit.updatedAt)}
          </span>
        </p>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-6 my-6'>
            <div className='flex-[32] flex flex-row items-center'>
              {disciplinaryCasesDemeritCurrentDemerit.main_user && (
                <Avatar
                  user={disciplinaryCasesDemeritCurrentDemerit.main_user}
                />
              )}
              <div className='flex flex-col ml-4'>
                <span className='text-sm text-valley-light-gray'>Студент</span>
                <span className='text-[15px] text-valley-black font-medium'>
                  {/* {disciplinaryCasesDemeritCurrentDemerit.main_user
                    ? JSON.stringify(disciplinaryCasesDemeritCurrentDemerit)
                    : disciplinaryCasesDemeritCurrentDemerit.main_user
                        ?.json_saved_data.firstname +
                      " " +
                      disciplinaryCasesDemeritCurrentDemerit.main_user
                        ?.json_saved_data.lastname} */}
                  {disciplinaryCasesDemeritCurrentDemerit.main_user
                    ? `${disciplinaryCasesDemeritCurrentDemerit.main_user.json_saved_data.firstname} ${disciplinaryCasesDemeritCurrentDemerit.main_user.json_saved_data.lastname}`
                    : `${
                        disciplinaryCasesDemeritCurrentDemerit.students
                          ? disciplinaryCasesDemeritCurrentDemerit.students
                              .map(
                                (s) =>
                                  `${s.json_saved_data.firstname} ${s.json_saved_data.lastname}`,
                              )
                              .join(", ")
                          : ""
                      }`}
                </span>
              </div>
            </div>
            <div className='flex-[21] flex flex-col'>
              <span className='text-sm text-valley-light-gray'>
                Тип нарушения
              </span>
              <span className='text-[15px] text-valley-black font-medium'>
                {
                  disciplinaryCasesDemeritCurrentDemerit.demerit_type
                    .common_demerit_type.name
                }
              </span>
            </div>
            <div className='flex-[47] flex flex-col'>
              <span className='text-sm text-valley-light-gray'>
                Описание нарушения
              </span>
              <span className='text-[15px] text-valley-black font-medium'>
                {disciplinaryCasesDemeritCurrentDemerit.description}
              </span>
            </div>
          </div>
          <div className='flex flex-col'>
            <span className='text-sm text-valley-light-gray'>
              Доказательства нарушений (фото/видео/скрин/письменное обращение
              пострадавших)
            </span>
            <span className='text-[15px] text-valley-black font-medium'>
              {disciplinaryCasesDemeritCurrentDemerit.incident_link ||
                "(пусто)"}
            </span>
          </div>
        </div>
        <div className='flex flex-col flex-1 overflow-y-auto gap-2'>
          {documentLabels.map((l) => {
            const foundMedia =
              disciplinaryCasesDemeritCurrentDemerit.media.find(
                (m) => m.demerit_media.label === l.label,
              );
            return (
              <div className='flex flex-row items-center py-[9px] gap-4'>
                <span className='flex-[2] shrink-0 text-sm font-medium text-valley-gray'>
                  {l.label}
                </span>
                <div className='flex-[3] shrink-0 min-w-0 flex flex-row'>
                  {foundMedia ? (
                    <FileUploadWithPreview
                      value={foundMedia}
                      buttonKeys={["view", "download"]}
                    />
                  ) : (
                    <div className='flex flex-row flex-1 items-center justify-center px-3 py-[25.5px] rounded-lg border border-valley-background-blue'>
                      <span className='text-sm leading-[15.4px] text-valley-gray'>
                        Отсутствует
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
